<template lang="pug">
  v-card
    v-card-title
      h2.card-title.mb-3 {{ 'base.edit_period' | translate }}
    v-card-content
      v-input-r.mb-3(
        :focus="true"
        :label="$t('base.name')"
        v-model="form.name")
      v-time-field.mb-3(
        :from="form.loading_time_from"
        :to="form.loading_time_to"
        @updateTime="updateTimeHandler"
        class="mb-3"
      )
      //v-switch(
      //  :label="$t('base.activate')"
      //  v-model="form.is_active")
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        @click="onUpdate") {{ 'base.save' | translate }}
      delete-btn(
        :disabled="!allowDelete"
        @delete="onDelete")
</template>

<script>
import api from '@/api'

import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'SettingsPeriodModal',

  components: {
    DeleteBtn
  },

  props: {
    id: {
      type: Number,
      required: true
    },

    status: {
      type: Boolean,
      reuqired: true
    },

    period: {
      type: Object,
      reuqired: true
    }
  },

  data: () => ({
    form: {
      name: '',
      loading_time_from: '',
      loading_time_to: '',
      is_active: true
    },
    loading: false
  }),

  created () {
    this.form.name = this.period.name
    this.form.loading_time_from = this.period.loading_time_from
    this.form.loading_time_to = this.period.loading_time_to
    this.form.is_active = this.status
  },

  methods: {
    async onUpdate () {
      this.loading = true
      const payload = {
        farm: this.period.farm,
        name: this.form.name,
        loading_time_to: this.form.loading_time_to,
        loading_time_from: this.form.loading_time_from,
        ordering: this.period.ordering
      }
      const id = this.$route.query.loading
      const { errors } = await api.loadings.updateById(id, payload)
      this.loading = false
      await this.updateStatus()
      if (!errors) {
        this.$emit('update')
        this.$emit('close')
      }
    },

    async onDelete () {
      const id = this.$route.query.loading
      await api.loadings.deleteById(id)
      this.$emit('update')
      this.$emit('close')
    },

    async updateStatus () {
      const payload = {
        is_active: this.form.is_active,
        planned_on: this.$route.query.date
      }
      await api.schedule.loadings.updateById(this.id, payload)
      this.$emit('update')
    },
    updateTimeHandler (startTime, endTime) {
      this.form.loading_time_from = startTime
      this.form.loading_time_to = endTime
    }
  },

  computed: {
    allowDelete () {
      return this.hasPermission('loading', 'delete')
    }
  }
}
</script>
